import { useEffect, useState } from "react";
import { useObjectCard } from "../context/ObjectCardProvider";
import { CountBadge, OperationWarehouse, OperStatBadge, ProductOperPrice } from 'modules/warehouse';
import { ProductTitle } from 'modules/product';
import { DateTime as DT } from "luxon";
import { UserNameItem } from 'modules/user';
import vconst from "utils/helpers/structs/vconst";
import { Badge, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import OperationInfoItem from "./OperationInfoItem";
import FormInput from "components/forms/FormInput";
import SpinnerBlock from "components/others/SpinnerBlock";
import * as apiWarehouse from "api/apiWarehouses";
import { useToast } from "context/ToastContext";
import { format$Price } from "utils/helpers/functions/formatPrice";
import { escapeHtml } from "utils/helpers/functions/escapeHtml";
 
const OperationInfo = ({ operationInfo, fetchOperarion }) => {
  
    const { t } = useTranslation(['Warehouses']);
    const { vObject } = useObjectCard();
    const { showToast } = useToast(); 
    const [ editDescription, setEditDescription ] = useState(false);
    const [ savingDescription, setSavingDescription ] = useState(false);
    const o = vObject?.operations?.find(o=>o.ID == operationInfo?.operation?.ID);
    const dt = DT.fromMillis(operationInfo?.operation?.dt||0).toLocaleString(DT.DATETIME_FULL)
    const dtReversal = DT.fromMillis(operationInfo?.operation?.dtReversal||0).toLocaleString(DT.DATETIME_FULL)
    const dtApproved = DT.fromMillis(operationInfo?.operation?.dtApproved||0).toLocaleString(DT.DATETIME_FULL)
    const totalPrice = (operationInfo?.operation?.operPrice||0) * (operationInfo?.operation?.operCount||0); 
    const totalPriceSale = (operationInfo?.operation?.operPriceSale||0) * (operationInfo?.operation?.operCount||0); 

    const handleSaveDescription = async (newDescription) => {
        console.log(newDescription);
        setSavingDescription(true);
        const resDescr = await apiWarehouse.setDescriptionOperation(operationInfo.operation.ID, newDescription);
        if (!resDescr) showToast(t('common:messError'), 'danger');
        await fetchOperarion();
        setSavingDescription(false)
        
    }
    
    
    return (<>
        <OperationInfoItem
            title={t('fields.prodName')}
            infoJsx={(
                <CountBadge count={operationInfo.operation.operCount}/>)}>
                <div className="d-flex justify-content-between border-bottom pb-2 mb-3">
                        <ProductTitle product={operationInfo?.product}/>  
                    <div className="text-end" style={{minWidth:'100px'}}>
                        <ProductOperPrice showSalePrice operation={operationInfo?.operation}/>
                    </div>
                </div>
                <div>
                    <h6 className="mb-0 pb-0 w-100 text-end"><span className="pe-1 text-muted fw-medium">{t('fields.total')}:</span>{format$Price(totalPrice)}</h6> 
                    <p className="f-12 mb-0 text-truncate w-100 text-end">{format$Price(totalPriceSale)}</p>
                </div>
        </OperationInfoItem> 

        <OperationInfoItem
            title={t('fields.warehouse')}
            infoJsx={(
                <OperStatBadge
                    operStatus={operationInfo.operation.operStatus}/>)}> 
            <OperationWarehouse operation={o}/> 
        </OperationInfoItem>
 
        <OperationInfoItem
            title={t('labelDescription')}
            infoJsx={(
                <Button
                    className="py-0"
                    variant="light-secondary"
                    size="sm" 
                    onClick={()=>{
                        setEditDescription(true);
                }}><i className="bi bi-pencil-square me-1"></i>{t('btnChange')}</Button>
            )}>
            <SpinnerBlock show={savingDescription} onlyBlur={true} />
            {!editDescription
                ? (<div dangerouslySetInnerHTML={{__html:escapeHtml(operationInfo.operation.operDescription||'-').replace(/\n/g, '<BR>')}}>{}</div>)
                : (<FormInput
                    defaultValue={operationInfo.operation.operDescription||''}
                    showForm={editDescription}
                    setShowForm={setEditDescription}
                    as="textarea"
                    callBack={handleSaveDescription}/>)}
            
        </OperationInfoItem>

        <OperationInfoItem
            title={t('fields.owner')}
            infoText={dt}>
            <UserNameItem user={operationInfo.owner}/>
        </OperationInfoItem>

        {operationInfo.ownerApproved && (
            <OperationInfoItem
                bg='bg-light-success'
                title={t('fields.ownerApproved')}
                infoText={dtApproved}>
                <UserNameItem user={operationInfo.ownerApproved}/>
            </OperationInfoItem>)}

        {operationInfo.ownerReversal && (
            <OperationInfoItem
                bg='bg-light-danger'
                title={t('fields.ownerReversal')}
                infoText={dtReversal}>
                <UserNameItem user={operationInfo.ownerReversal}/>
            </OperationInfoItem>)}
    </>);
};

export default OperationInfo;
